import { render, staticRenderFns } from "./DeviceInfoPerformace.vue?vue&type=template&id=6b972d7a&"
import script from "./DeviceInfoPerformace.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoPerformace.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfoPerformace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports